module.exports = __webpack_public_path__ + "img/lgmake_payment.5bbb324c.jpg";